module.exports = __webpack_public_path__ + "img/Dantam Hair 37.cafa8e0b.jpg";